export default __webpack_public_path__ + "static/fudevicon-4909125e8e131e7ebc5119b5d897278f.png";